import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { getCustomPropertiesFromObject } from 'helpers/shared';
import generateAxPalette from 'helpers/ax-palette';
import { Helmet } from 'react-helmet';
import humps from 'humps';
import isEmpty from 'ramda/src/isEmpty';
import AxStagesDrawer from 'ax/components/AxStagesDrawer';
import AxHeader from '../ax-header';

const stages = [
  {
    extra: {},
    id: 36,
    name: 'DataCollectionStage',
    position: 1,
    selected: false,
    title: 'personal information',
  },
  {
    extra: {},
    id: 38,
    name: 'SchedulerStage',
    position: 2,
    selected: true,
    title: 'schedule interview',
  },
  {
    extra: {},
    id: 7,
    name: 'CustomStage',
    position: 3,
    selected: false,
    title: 'Interview',
  },
];

export default class AxPreview extends PureComponent {
  static propTypes = {
    brand: PropTypes.shape({
      axPalette: PropTypes.shape({
        primaryDark: PropTypes.string,
        white: PropTypes.string,
        grey1: PropTypes.string,
        grey2: PropTypes.string,
        grey3: PropTypes.string,
        grey4: PropTypes.string,
        grey5: PropTypes.string,
        boxShadow1: PropTypes.string,
        inputInset: PropTypes.string,
        inputOutline: PropTypes.string,
      }),
      logo: PropTypes.string,
      jobDirectoryBanner: PropTypes.string,
      jobDirectoryBannerPreview: PropTypes.string,
    }),
    /* eslint-disable */
    defaultAxPalette: PropTypes.object,
    /* eslint-enable */
    aiCareerSiteEnabled: PropTypes.bool,
  }

  static defaultProps = {
    brand: {},
    aiCareerSiteEnabled: false,
  }

  _handleUploadClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  _renderHelmet = () => {
    const { brand, defaultAxPalette } = this.props;

    if (!brand || isEmpty(brand)) {
      return false;
    }

    if (!brand.styles || isEmpty(brand.styles)) {
      return false;
    }

    if (!brand && !brand.axPalette) {
      return false;
    }

    const currentAxPalette = brand.axPalette || defaultAxPalette;
    const styleObj = currentAxPalette ? generateAxPalette(currentAxPalette) : null;

    return (
      <Helmet>
        <style type="text/css">
          {getCustomPropertiesFromObject(styleObj)}
        </style>
      </Helmet>
    );
  }

  render() {
    const {
      brand: {
        axPalette,
        logo,
        squareLogo,
        squareLogoPreview,
        headerText,
        jobDirectoryBanner,
        jobDirectoryBannerPreview,
      },
      defaultAxPalette,
      aiCareerSiteEnabled,
    } = this.props;

    const currentAxPalette = axPalette || defaultAxPalette;
    return (
      <Fragment>
        {this._renderHelmet()}
        <div className="openings-directory-layout__ax ax-preview-container">
          <div className="ax-preview-elements">
            <div className="ax-preview-header top-level preview">
              Brand Preview
              <p className="ax-preview-subheader">A sample of how your logos and color will be displayed</p>
            </div>
            <div className="ax-preview-header">
              Logos Preview
            </div>
            <div className="ax-preview-section">
              <div>
                <div className="ax-preview-label">
                  Default Logo
                </div>
                <div className="ax-preview-drawer">
                  <AxStagesDrawer
                    brandLogoUrl={logo}
                    progress={29}
                    rotation={104.4}
                    stages={stages}
                    axPalette={humps.decamelizeKeys(currentAxPalette, { split: /(?=[A-Z0-9])/ })}
                    progressFraction="2/7"
                    isOpen
                  />
                </div>
              </div>
              <div>
                <div className="ax-preview-label">
                  Square Logo
                </div>
                <div className="ax-preview-vertical-center">
                  <AxHeader
                    logo={squareLogoPreview || squareLogo || logo}
                    headerText={headerText}
                    preview
                  />
                </div>
              </div>
            </div>
            <div className="ax-preview-header">
              Color Preview
            </div>
            <div className="ax-preview-section">
              <div className="form-group ax ax-file-upload-form ">
                <div className="ax-preview-label">
                  File uploading
                </div>
                <div className="ax-file-upload-container">
                  <input
                    type="file"
                    className="ax-file-upload form-control js-blurry-detection"
                    data-only-images="false"
                    onClick={this._handleUploadClick}
                  />
                  <div className="ax-circular-progress">
                    <svg width="82" height="82" viewBox="0 0 72 72">
                      <circle className="circle-progress" cx="36" cy="36" r="32" strokeWidth="2px" transform="rotate(-90 36 36)" style={{ strokeDasharray: '259.062', strokeDashoffset: '201.062' }} />
                    </svg>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" className="ax-upload-icon">
                    <g fill="none" fillRule="evenodd" stroke="#865BF4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                      <path d="M8.5 11.5V.5M13.5 5.5l-5-5-5 5M15.5 15.5h-14" />
                    </g>
                  </svg>
                </div>
              </div>
              <div className="ax-preview-button-container">
                <div>
                  <div className="ax-preview-label">
                    Default Button
                  </div>
                  <div className="ax-preview-vertical-center">
                    <button className="ax-button">
                      <span>Continue</span>
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                        <path d="M6.434 12.27l3.445-3.445-3.445-3.445 1.055-1.055 4.5 4.5-4.5 4.5z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div>
                  <div className="ax-preview-label">
                    Disabled Button
                  </div>
                  <div className="ax-preview-vertical-center">
                    <button className="ax-button secondary">
                      <span>Continue</span>
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                        <path d="M6.434 12.27l3.445-3.445-3.445-3.445 1.055-1.055 4.5 4.5-4.5 4.5z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {aiCareerSiteEnabled && (
              <Fragment>
                <div className="ax-preview-header">
                  Jobs Directory Preview
                </div>
                <div className="ax-preview-section">
                  <div className="ax-jobs-directory-preview">
                    {logo && (
                      <div className="ax-jobs-directory-logo">
                        <img src={logo} alt="Brand Logo" />
                      </div>
                    )}
                    {(jobDirectoryBannerPreview || jobDirectoryBanner) && (
                      <div className="ax-jobs-directory-banner">
                        <img
                          src={jobDirectoryBannerPreview || jobDirectoryBanner}
                          alt="Job Directory Banner"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
